import {useState} from "react";

export default function useFaqComponent() {
    const [dropdown , setDropdown] = useState(false);

    const toggleDropdown = () => {
        setDropdown(!dropdown);
    }
    return {toggleDropdown,dropdown}
}